var currentUrl = window.location.href;
const defaults = {
    cartModal: '.js-ajax-cart-modal', // classname
    cartModalContent: '.js-ajax-cart-modal-content', // classname
    cartDrawer: '.js-ajax-cart-drawer', // classname
    cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
    cartDrawerClose: '.js-ajax-cart-drawer-close', // classname
    cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
    cartOverlay: '.js-ajax-cart-overlay', // classname
    cartCounter: '.cartCount', // classname
    addToCart: '.js-ajax-add-to-cart', // classname
    removeFromCart: '.js-ajax-remove-from-cart', //classname
    removeFromCartNoDot: 'js-ajax-remove-from-cart', //classname,
    checkoutButton: '.js-ajax-checkout-button',
};

const cartModal = document.querySelector(defaults.cartModal);
const cartModalContent = document.querySelector(defaults.cartModalContent);
const cartDrawer = document.querySelector(defaults.cartDrawer);
const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
const cartDrawerClose = document.querySelector(defaults.cartDrawerClose);
const cartOverlay = document.querySelector(defaults.cartOverlay);
const cartCounter = document.querySelector(defaults.cartCounter);
let removeFromCart = document.querySelectorAll(defaults.removeFromCart);
const checkoutButton = document.querySelector(defaults.checkoutButton);
const htmlSelector = document.documentElement;

function addProductToCart(formID) {
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('#' + formID)
            .serialize(),
        success: addToCartOk,
        error: addToCartFail,
    });

}
function removeAttributes() {
  document.getElementsByClassName("js-ajax-add-to-cart")[0].removeAttribute("type");
  document.getElementsByClassName("js-ajax-add-to-cart")[0].setAttribute("disabled", true);

  document.querySelector('.js-ajax-add-to-cart span').innerHTML = "Item is in cart"
  setTimeout(() => {
    document.getElementsByClassName("js-ajax-add-to-cart")[0].removeAttribute("name");
    document.getElementsByClassName("js-ajax-add-to-cart")[0].classList.remove("js-ajax-add-to-cart")
  }, 3000);
  

}
function fetchCart(originator) {

    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {

            if (cart.item_count === 0) {
                cartDrawerContent.innerHTML = `
                <style>.progress-bar_wrapper, .amount-away-container{display:none;}</style>
                <div class="cart-empty">
                    <h4 class="cart-empty__title">Your cart is currently empty.</h4>
                    <a href="/collections/all" class="ss-button ss-side-button">Shop now</a>
                </div>`;
                //checkoutButton.classList.add('is-hidden');
               $(".ajax-cart-drawer__button-and-subtotal").addClass("is-hidden");
              $(".free-shipping-heading").html("").addClass("empty");
              $(".subtotal-amount").html("");
            } else {
                renderCart(cart,originator);
                //checkoutButton.classList.remove('is-hidden');
              $(".ajax-cart-drawer__button-and-subtotal").removeClass("is-hidden");
               $(".free-shipping-heading").removeClass("empty");

            }

        }
    });
}

function changeItem(data, callback) {
    const quantity = data.quantity;
    let lastQueryParm = `&${data.id != undefined ? `id=${data.id}`: `line=${data.line}`}`
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + lastQueryParm,
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                fetchCart();
                removeProductFromCart();
            }
        },
    });
}

function onCartUpdate(cart) {
    if( document.querySelector(`.cart-count-bubble`)){
        document.querySelector(`.cart-count-bubble`).firstElementChild.innerHTML = cart.item_count
        document.querySelector(`.cart-count-bubble`).firstElementChild.nextElementSibling.innerHTML = `${cart.item_count} items`
    }
    if(document.querySelector(`.progress-bar_wrapper`)){
      updateProgressBar();
    }

}

function addToCartOk(product) {
    fetchCart();
    setTimeout(() => {
        openCartDrawer();
        openCartOverlay();
    }, 250);


}

function removeProductFromCart() {
    // cartCounter.innerHTML = Number(cartCounter.innerHTML) - 1;
}

function addToCartFail() {
    cartModalContent.innerHTML = 'The product you are trying to add is out of stock.';
    openAddModal();
    openCartOverlay();
}

function renderCart(cart,originator) {
    if(originator == null || originator != "gift"){
        onCartUpdate(cart);
    }
    clearCartDrawer();
    let moneyFormat = "$";
    cart.items.forEach(function(item, index) {
        let itemPropertiesHtml = "";
        let itemProperties = item.variant_options;
        
      
      if(itemProperties && Object.keys(itemProperties).length) {
        for (let key in itemProperties) {
          
            if(!key.startsWith("_") && itemProperties[key] != "Default Title")
              
              itemPropertiesHtml += `<p class="ajax-cart-item-property">${item.options_with_values[key].name}: ${itemProperties[key]}</p>`;
		}
      }
      
      let linePriceHtml = "";
      
      if(item.final_line_price < item.original_line_price) {
        
        linePriceHtml = `<span class="compare-at-line-price"><s>${Shopify.formatMoney(item.original_line_price, moneyFormat)}</s></span><span class="original-line-price">${Shopify.formatMoney(item.final_line_price, moneyFormat)}</span>`;
        
      } else {
      
        linePriceHtml = `<span class="original-line-price">${Shopify.formatMoney(item.final_line_price, moneyFormat)}</span>`;
      }

      let cartItemHtml = `<div class="ajax-cart-item" data-variant="${item.variant_id}" data-line="${Number(index + 1)}">
<div class="ajax-cart-item-image-container"><a href="${item.original_line_price == 0 ? `javscript:void(0)` : item.url}"><img class="ajax-cart-item__image" alt="${item.title}" src="${item.image}" ></a> </div>
<div class="ajax-cart-item-middle-part">
<div class="ajax-cart-item__title"><a href="${item.original_line_price == 0 ? `javscript:void(0)` : item.url}">${item.title}</a> ${item.original_line_price == 0 ? `` : `<div class="ajax-cart-item-remove  ${defaults.removeFromCartNoDot}"><i class="icon icon--close" aria-hidden="true"></i>X</div>`}</div>
<div class="ajax-cart-item-properties">${itemPropertiesHtml}</div>

${ 
    item.original_line_price == 0 ? `` : item.product_title.includes('$5 Dollar Club') || item.product_title.includes('(2DT)') ? '':`<div class="ajax-cart-item-quantity-container">
    <div class="cart-item__qty"><div class="js-qty">
        <button type="button" class="js-qty__adjust js-qty__adjust--minus icon-fallback-text" data-id="${item.key}">
            <span aria-hidden="true">−</span>
        </button>
        <input type="text" class="js-qty__num ajax-cart-item__quantity" value="${item.quantity}" min="1" data-id="${item.key}" aria-label="quantity" pattern="[0-9]*" id="updates_${item.key}">
        <button type="button" class="js-qty__adjust js-qty__adjust--plus" data-id="${item.key}" >
            <span aria-hidden="true">+</span>
        </button>
    </div>
`
}
<div class="price-and-remove-item-wrapper"><div class="ajax-cart-item__price">${linePriceHtml}</div></div>
</div>
</div>

</div>`

        cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + cartItemHtml;

    });


    if(cart.items.length > 0 && document.getElementsByClassName("upsell-carousel-container")[0].style.display == "none") {
      document.getElementsByClassName("ajax-cart-drawer__content")[0].style.backgroundColor = "white";
      const images = document.getElementsByClassName("ajax-cart-item__image")
      for (var i = 0; i < images.length; i++) {
        images[i].style.opacity = 1;
      }
      const quantity = document.getElementsByClassName("js-qty");
      for (var i = 0; i < quantity.length; i++) {
        quantity[i].style.opacity = 1;
      }
    }
    else if(cart.items.length > 0 && document.getElementsByClassName("upsell-carousel-container")[0].style.display != "none") {
      document.getElementsByClassName("ajax-cart-drawer__content")[0].style.backgroundColor = "none";

    }

  $(".subtotal-amount").html(Shopify.formatMoney(cart.total_price, moneyFormat));

  
//   freeShippingMessage(cart);
   
    removeFromCart = document.querySelectorAll(defaults.removeFromCart);

    for (let i = 0; i < removeFromCart.length; i++) {
        removeFromCart[i].addEventListener('click', function() {
            //const line = this.parentNode.getAttribute('data-line');
          
          const line = $(this).closest(".ajax-cart-item").data("variant");
            
          let data = {
            id: line,
            quantity: 0
          };
            changeItem(data);
        });
    }

    console.log(`CART:`, (cart.total_price / 100).toFixed(2));
    document.querySelector(`.total-container`).firstElementChild.innerHTML = `$` + (cart.total_price / 100).toFixed(2);

}
function closeUpsells() {
  document.getElementsByClassName("upsell-carousel-container")[0].style.display = "none";
  document.getElementsByClassName("ajax-cart-drawer__content")[0].style.backgroundColor = "white";
  const images = document.getElementsByClassName("ajax-cart-item__image")
  for (var i = 0; i < images.length; i++) {
    images[i].style.opacity = 1;
  }
  const quantity = document.getElementsByClassName("js-qty");
  for (var i = 0; i < quantity.length; i++) {
    quantity[i].style.opacity = 1;
  }

  let bottom_height = document.querySelector(`.ajax-cart-drawer__button-and-subtotal`).offsetHeight;
  let top_height = (document.querySelector(`.ajax-cart-top-heading-container`).offsetHeight + document.querySelector(`.amount-away-container`).offsetTop + document.querySelector(`.progress-bar_wrapper`).offsetHeight);

  document.querySelector(`#fix-height`).innerHTML = `.ajax-cart-drawer__content {height: Calc(100% - ${(bottom_height + top_height) + 35}px) !important;}`
  
}
function addUpsellToCart(e) {
  addItemToCart(Number(e.dataset.upsellid), 1);
}
function openCartDrawer() {
  if(document.querySelectorAll('.upsell-carousel.slick-initialized').length == 0) {
    setTimeout(() => {
      $('.upsell-carousel').slick({
        dots: false,
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        centerPadding: "10%",
        prevArrow: `<svg class="flickity-button-icon left" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 80,80 L 45,50  L 80,20 L 60,0 Z" class="arrow"></path></svg>`,
        nextArrow: `<svg class="flickity-button-icon right" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 80,80 L 45,50  L 80,20 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>`,
        centerMode: true,
      });
    }, "500")

  }
    cartDrawer.classList.add('is-open');
  $('html').addClass('cart-drawer-open');

  setTimeout(() => {
    let bottom_height = document.querySelector(`.ajax-cart-drawer__button-and-subtotal`).offsetHeight;

    console.log("Bottom Height", bottom_height + 35)

    let top_height = (document.querySelector(`.ajax-cart-top-heading-container`).offsetHeight + document.querySelector(`.amount-away-container`).offsetTop + document.querySelector(`.progress-bar_wrapper`).offsetHeight);
  
    document.querySelector(`#fix-height`).innerHTML = `.ajax-cart-drawer__content {height: Calc(100% - ${((bottom_height + top_height) + 25)}px) !important;}`
  }, 1500);

}

function closeCartDrawer() {
    cartDrawer.classList.remove('is-open');
  $('html').removeClass('cart-drawer-open');
}

function clearCartDrawer() {
    cartDrawerContent.innerHTML = '';
}

function openAddModal() {
    cartModal.classList.add('is-open');
}

function closeAddModal() {
    cartModal.classList.remove('is-open');
}

function openCartOverlay() {
    cartOverlay.classList.add('is-open');
    htmlSelector.classList.add('is-locked');
}

function closeCartOverlay() {
    cartOverlay.classList.remove('is-open');
    htmlSelector.classList.remove('is-locked');
}

cartDrawerClose.addEventListener('click', function() {
    closeCartDrawer();
    closeCartOverlay();
});
// cart is empty stanje
cartOverlay.addEventListener('click', function() {
    closeAddModal();
    closeCartDrawer();
    closeCartOverlay();
});


if(!currentUrl.includes("/cart")) {

function checkoutCart(checkout){
  if(!checkout.classList.contains("js-disabled-button")){
    hasRechargeProduct();
  }
}


$(document).on("click", ".js-ajax-cart-drawer-trigger-mobile", function(event) {

  event.preventDefault();
    //fetchCart();
    openCartDrawer();
    openCartOverlay();
  
});
}
document.addEventListener('DOMContentLoaded', function() {
    const cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);
    fetchCart();
    cartDrawerTrigger.addEventListener('click', function(event) {
 
        event.preventDefault();
        openCartDrawer();
        openCartOverlay();
    });
    for (let i = 0; i < document.querySelectorAll(defaults.addToCart).length; i++) {
        document.querySelectorAll(defaults.addToCart)[i].addEventListener('click', function(event) {
          addToBagListener(event,i)
        });
    }

    window.addEventListener('pplrAddToCartCompleted' , function(e) {
      fetchCart()
      openCartDrawer()
    })

    if(document.referrer.includes("/cart")){
      openCartDrawer();
    }

});



if(!currentUrl.includes("/cart")) {
$(document).on("click", '.js-qty__adjust', function(e) {
e.preventDefault();
  console.log("test");
  var $el = $(this)
  , id = $el.data('id')
  , $qtySelector = $el.siblings('.js-qty__num')
  , qty = parseInt($qtySelector.val().replace(/\D/g, ''));
var qty = validateQty(qty);
if ($el.hasClass('js-qty__adjust--plus')) {
    qty += 1
} else {
    qty -= 1;
    if (qty < 1)
        qty = 0
}
let parentNode =this.parentElement.parentElement.parentElement.parentElement;
parentNode = parentNode.querySelector('.ajax-cart-item__title a')
$qtySelector.val(qty);
  
  let line = $(this).closest(".ajax-cart-item").data("line");
  
  let data = {
  
    line: line,
    quantity: qty
  }
  changeItem(data);
  
  
});
}
 validateQty = function(qty) {
   if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {} else {
     qty = 1
   }
   return qty
 }
 
 $(document).on("submit", ".js-ajax-cart-form.js-product-form", function(e) {
 
 e.preventDefault();
   
   
   $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $(this)
            .serialize(),
     success: function(response) {
     fetchCart();
     openCartDrawer();
     openCartOverlay();
    
     },
     error: function(error) {
     
     alert("This item is out of stock")
     },
    });

   return false;
 });

 function addItemToCart(variant_id, qty) {

    data = {
      "id": Number(variant_id),
      "quantity": qty
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function () {
          fetchCart();
          openCartOverlay();
          openCartDrawer();
      
      },
  
      error: function () {
        alert("Sorry, That item is not available")
      }
    });
}
  
function reChargeProcessCart() {
	function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
	do {
      		token=get_cookie('cart');
	}
    while(token == undefined);	
    let myshopify_domain = Shopify.shop;
	try { let ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
	return "https://checkout.rechargeapps.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+ga_linker;
}

function hasRechargeProduct(){
    let isRechargeProduct = false;
    $.getJSON('/cart', function (results) {
    var has_subscription_product = false;
        $.each(results.items, function (i, item) {
            if( !has_subscription_product ){
                if(item.properties!== null){
                    $.each(item.properties, function (j, property) {
                        if(j=='shipping_interval_frequency'){
                            has_subscription_product = true;
                        }          
                    });
                }
            }  
        });
    if( has_subscription_product ){
        window.location.href = reChargeProcessCart();
    }else{
        window.location.href = "/checkout";
    }
});

    return isRechargeProduct;
}

const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  
    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });


  var Shopify = Shopify || {};
  Shopify.formatMoney = function(cents) {
    return formatter.format(cents / 100);
}
  

//GIFT BAR

//Calculates and Updates the UI for the progress bar under the header
function updateProgressBar() {

    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
            updateProgressBarElements(cart)
            disableCheckouButtonShortly();
            if(sessionStorage.getItem('gift-status-receive') == `true` || sessionStorage.getItem('gift-status-receive') == null){
                addGiftsAccordingToProgressBar(cart.total_price / 100, cart);
                removeGiftsAccordingToProgressBar(cart.total_price / 100,cart);
            }

        }
    })
  
  }

  function addToBagListener(event,i){
    event.preventDefault();
    let trigger = document.querySelectorAll(defaults.addToCart)[i];
    let formID = $(trigger).closest( "form" )[0].getAttribute('id')
    addProductToCart(formID);
  }
  
  function updateProgressBarElements(cart) {
    const progressBarFilled = document.querySelectorAll('#progress-bar-filled');
    const cartTotal = document.querySelector('#progress-bar-cart-total_amount');
    const amountAway = document.querySelector('#amount-away_amount');
    const freeGift = document.querySelector("#next-free-gift");
  
    let totalPrice = cart.total_price / 100;
  
  
    let image_wrappers = document.getElementsByClassName("progress-bar_images_wrapper")[0];
    if (image_wrappers.children.length != 0) {
      let amountAwayAmount = calculateAmountAway(totalPrice);
      let percentage = calculateProgressWidth(totalPrice);
      amountAway.innerHTML = `$${amountAwayAmount.toFixed(2)}`;
  
      var progressBarImages = document.getElementsByClassName('progress-bar-image');
      var dollarAmount = document.getElementsByClassName('progress-bar-price');
  
      let x = 0;
      let notMet = false;
      document.querySelector('.dollar-amounts_wrapper_mobile').querySelectorAll('.dollar-amount_cell').forEach(cell => {
        let price = cell.firstElementChild.innerHTML.split("$")[1];
        let title = cell.firstElementChild.dataset.title;
        let alteredPrice = totalPrice.toFixed(2)
        if(alteredPrice < Number(price) && notMet == false){
          notMet = true;
          freeGift.innerHTML = ` ${title.includes("+") ? title.split("+")[1] : title}`;
        }
        if(alteredPrice > Number(price)){
          document.querySelectorAll('.progress-bar-image')[x].classList.add("active-border")
          document.querySelectorAll('.cartprizes')[x].classList.add("progress-bar-price-active") 
          
        }else{
          document.querySelectorAll('.progress-bar-image')[x].classList.remove("active-border")
          document.querySelectorAll('.cartprizes')[x].classList.remove("progress-bar-price-active")      
        }
  
        x++;
      })
  
      progressBarFilled.forEach(progressBar => {
        progressBar.style.width = `${percentage}%`;
  
        if (percentage === 100) {
          progressBar.style.borderRadius = "30px 30px 30px 30px";
        } else {
          progressBar.style.borderRadius = "30px 0px 0px 30px";
        }
      })

      if(percentage == 100){
        let gift_items = JSON.parse(document.querySelector("[data-progress_bar_items]").dataset.progress_bar_items)
        freeGift.innerHTML = gift_items[gift_items.length -1].item_title
        document.getElementById('final-unlock').innerHTML = gift_items[gift_items.length -1].item_title;
        document.querySelector(`.cart-amount-away_wrapper-unlocked`).style.display = "block";
        document.querySelector(`.cart-amount-away_wrapper`).style.display = "none"
      }else{
        document.querySelector(`.cart-amount-away_wrapper-unlocked`).style.display = "none";
        document.querySelector(`.cart-amount-away_wrapper`).style.display = "block"
      }
    }
  
    const dollarAmountCells = document.querySelectorAll('.dollar-amount_cell');
    const dollarAmountWidthInPercentage = 1 / (dollarAmountCells.length / 2);
    for (let i = 0; i < dollarAmountCells.length; i++) {
      dollarAmountCells[i].style.width = `${dollarAmountWidthInPercentage * 100}%`;
    }
    const progressBarImageWrappers = document.querySelectorAll(".progress-bar-image_wrapper");
    const imagesWrappersWidthInPercentage = 1 / (progressBarImageWrappers.length / 2);
    for (let i = 0; i < progressBarImageWrappers.length; i++) {
      progressBarImageWrappers[i].style.width = `${imagesWrappersWidthInPercentage * 100}%`;
    }
  }
  
  function addGiftsAccordingToProgressBar(dollarsSpent, cart) {
  
    let progressBarItemDataElement = document.querySelector("#progressBarItemData");
    let progressBarItemDataParsed = progressBarItemDataElement.dataset.progress_bar_items;
    let progressBarItemData = JSON.parse(progressBarItemDataParsed);
  
    let pricings = []
    for (let i = 0; i < progressBarItemData.length; i++) {
      pricings.push(progressBarItemData[i].item_price);
    }
  
    let prizeIds = [];
    for (let i = 0; i < progressBarItemData.length; i++) {
      prizeIds.push(progressBarItemData[i].item_id);
    }

    for (let i = 0; i < pricings.length; i++) {
        if (dollarsSpent >= pricings[i]) {
            // prizeIds[i] to cart
            let addToCart = true;
            if(cart.items.filter(item => item.variant_id == Number(prizeIds[i])).length > 0){
                addToCart = false;
            }

            if (addToCart && prizeIds[i] != 0) {
            data = {
                "id": Number(prizeIds[i]),
                "quantity": 1,
                "properties": {_upsell: true}
            }

            jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: data,
              dataType: 'json',
              async: false,
              success: function (cart) {
              fetchCart("gift");
              },
              error: function(e){
              }
          });    

            }
        }
    }
  


  }
  
  function removeGiftsAccordingToProgressBar(dollarsSpent, cart) {
    let progressBarItemDataElement = document.querySelector("#progressBarItemData");
    let progressBarItemDataParsed = progressBarItemDataElement.dataset.progress_bar_items;
    let progressBarItemData = JSON.parse(progressBarItemDataParsed);
  
    let pricings = []
    for (let i = 0; i < progressBarItemData.length; i++) {
      pricings.push(progressBarItemData[i].item_price);
    }
  
    let prizeIds = [];
    for (let i = 0; i < progressBarItemData.length; i++) {
      prizeIds.push(progressBarItemData[i].item_id);
    }
  
    for (let i = 0; i < pricings[i]; i++) {
      if (dollarsSpent < pricings[i]) {
        // prizeIds[i] to card
  
        let containsItem = false;
        let itemToBeRemoved = null;
        let cartHasPrize = cart.items.filter(item => item.variant_id == Number(prizeIds[i])).length > 0;
        if(cart.items.filter(item => item.variant_id == Number(prizeIds[i])).length > 0){
            containsItem = true;
            itemToBeRemoved = prizeIds[i];
        }

  
        if (containsItem && prizeIds[i] != 0 && cartHasPrize) {
          // Shopify.removeItem(prizeIds[i], onCartUpdateCustom(cart));
          console.log(123);
          jQuery.post('/cart/update.js', 'updates[' + prizeIds[i] + ']=0').then((success)=>{
            fetchCart();
          })
        }
  
      }
    }
  }
  
  function calculateAmountAway(dollarsSpent) {
  
    let progressBarItemDataElement = document.querySelector("#progressBarItemData");
    let progressBarItemDataParsed = progressBarItemDataElement.dataset.progress_bar_items;
    let progressBarItemData = JSON.parse(progressBarItemDataParsed);
  
    let pricings = []
    for (let i = 0; i < progressBarItemData.length; i++) {
      pricings.push(progressBarItemData[i].item_price);
    }
  
    if (dollarsSpent >= progressBarItemData[progressBarItemData.length - 1].item_price) {
      return 0;
    } else {
      for (let i = 0; i < pricings.length; i++) {
        if (pricings[i] > dollarsSpent) {
          return pricings[i] - dollarsSpent;
        }
      }
    }
  }
  
  function calculateProgressWidth(dollarsSpent) {
  
    let progressBarItemDataElement = document.querySelector("#progressBarItemData");
    let progressBarItemDataParsed = progressBarItemDataElement.dataset.progress_bar_items;
    let progressBarItemData = JSON.parse(progressBarItemDataParsed);
    if(dollarsSpent == 0) {
      return 0;
    }
    if (progressBarItemData != []) {
      let totalPercentage = 0;
      let eachItemWidth = 1 / progressBarItemData.length;
  
      if (dollarsSpent >= progressBarItemData[progressBarItemData.length - 1].item_price) {
        return 100;
      }
      for (let i = 0; i < progressBarItemData.length; i++) {
  
        if (i === 0) {
          if (dollarsSpent >= progressBarItemData[i].item_price) {
            totalPercentage += eachItemWidth * 100;
          } else {
            let percentageOfTier = dollarsSpent / progressBarItemData[i].item_price;
            let extraPercentage = percentageOfTier * eachItemWidth;
            return (extraPercentage - 0.13) * 100;
          }
        } else {
          if (dollarsSpent >= progressBarItemData[i - 1].item_price) {
            if (dollarsSpent >= progressBarItemData[i].item_price) {
              totalPercentage += eachItemWidth * 100;
            } else {
              let percentageOfTier = (dollarsSpent - progressBarItemData[i - 1].item_price) / (progressBarItemData[i].item_price - progressBarItemData[i - 1].item_price);
              let extraPercentage = percentageOfTier * eachItemWidth;
              totalPercentage += extraPercentage * 100;
            }
          } else {
            totalPercentage = totalPercentage - 13;
  
            return totalPercentage;
          }
        }
      }
  
      if (totalPercentage >= 100) {
        return 100;
      } else {
        totalPercentage = totalPercentage - 13;
        return totalPercentage;
      }
  
    }
  
  }

  function disableCheckouButtonShortly(){
    document.querySelector(`.js-ajax-checkout-button`).classList.add("js-disabled-button");
    setTimeout(() => {
      document.querySelector(`.js-ajax-checkout-button`).classList.remove("js-disabled-button");
    }, 1750);
  }